export default {
  clientLogo: '/static/imgs/TEMP/client-logo.png',
};
